import { createUID } from '@pega/cosmos-react-core/lib/utils';
import type { FileItemProps, FileDisplayProps } from '@pega/cosmos-react-core';

export const displayFiles: FileDisplayProps[] = [
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'Aquaman',
    thumbnail: 'https://image.tmdb.org/t/p/w342//7lTnXOy0iNtBAdRP3TZvaKJ77F6.jpg',
    value: 'https://image.tmdb.org/t/p/w342//7lTnXOy0iNtBAdRP3TZvaKJ77F6.jpg'
  },
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'How to train your dragon.pdf',
    thumbnail: 'https://image.tmdb.org/t/p/w342//ygGmAO60t8GyqUo9xYeYxSZAR3b.jpg',
    value: 'https://image.tmdb.org/t/p/w342//ygGmAO60t8GyqUo9xYeYxSZAR3b.jpg'
  },
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'The Marvels',
    thumbnail: 'https://image.tmdb.org/t/p/w342//9GBhzXMFjgcZ3FdR9w3bUMMTps5.jpg',
    value: 'https://image.tmdb.org/t/p/w342//9GBhzXMFjgcZ3FdR9w3bUMMTps5.jpg'
  },
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'Migration',
    value: 'https://image.tmdb.org/t/p/w342//ldfCF9RhR40mppkzmftxapaHeTo.jpg',
    thumbnail: 'https://image.tmdb.org/t/p/w342//ldfCF9RhR40mppkzmftxapaHeTo.jpg'
  },
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'Constellation.pdf',
    value: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'Infinity.doc',
    value: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.doc'
  },
  {
    id: createUID(),
    onPreview: () => {},
    onDownload: () => {},
    displayText: 'Architecture.ppt',
    value: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.ppt'
  }
];

export const fileItems: FileItemProps[] = [
  {
    id: createUID(),
    name: 'Aquaman',
    thumbnail: 'https://image.tmdb.org/t/p/w342//7lTnXOy0iNtBAdRP3TZvaKJ77F6.jpg',
    format: 'jpg',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  },
  {
    id: createUID(),
    name: 'How to train your dragon.pdf',
    thumbnail: 'https://image.tmdb.org/t/p/w342//ygGmAO60t8GyqUo9xYeYxSZAR3b.jpg',
    format: 'jpg',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  },
  {
    id: createUID(),
    name: 'The Marvels',
    thumbnail: 'https://image.tmdb.org/t/p/w342//9GBhzXMFjgcZ3FdR9w3bUMMTps5.jpg',
    format: 'jpg',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  },
  {
    id: createUID(),
    name: 'Migration',
    thumbnail: 'https://image.tmdb.org/t/p/w342//ldfCF9RhR40mppkzmftxapaHeTo.jpg',
    format: 'jpg',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  },
  {
    id: createUID(),
    name: 'Constellation.pdf',
    format: 'pdf',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  },
  {
    id: createUID(),
    name: 'Infinity.doc',
    format: 'doc',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  },
  {
    id: createUID(),
    name: 'Architecture.ppt',
    format: 'ppt',
    onDelete: () => {},
    onPreview: () => {},
    onDownload: () => {},
    onEdit: () => {}
  }
];
